// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1zL0b","featured_games_results":"style_featured_games_results__mmi8V"};